export default __webpack_public_path__ + "static/media/plus.da6c9e88.svg";